export default {
  paged: {
    select:
      'id,isActive,status,canCreatePartners,canCreateResellers,canCreateCustomers,partnerAgreementMode',
    searchSelect: ['company/commercialName', 'ownerCompany/commercialName', 'agreement/name'],
    orderBy: 'company/commercialName asc',
    expand: {
      company: {
        select: 'commercialName',
      },
      ownerCompany: {
        select: 'commercialName',
      },
      agreement: {
        select: 'name',
      },
    },
  },
  itemDetail: {
    expand: {
      company: {
        select: 'commercialName',
      },
      ownerCompany: {
        select: 'commercialName',
      },
      agreement: {
        select: 'name',
      },
      defaultPartnerAgreement: {
        select: 'name',
      },
      defaultResellerAgreement: {
        select: 'name',
      },
    },
  },
};
